// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"4b260a7a","728":"2070073a","794":"0b85b893","822":"ba091f3c","911":"237f30fc","914":"5d540169"}[chunkId] + ".css";
};